module.exports = __webpack_public_path__ + "static/media/VIA3.581dd02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/AMI_assistant/assets/VIA3.png
// module id = 576
// module chunks = 1